<a [routerLink]="link" class="bg-custom-green text-white px-4 py-2 rounded-md">
    {{ text }}
</a>
  